/** Where the portal lives. Must match vite's `base` and the router basepath. */
export const BASEPATH = "/portal";

/**
 * Sanitise the `?redirect=` a login link carries.
 *
 * This value comes out of the URL bar, so it is attacker-controlled: left
 * alone it is an open redirect, and an open redirect on a login page is how a
 * phishing link ends up looking like it came from us. Anything that is not a
 * plain path inside the portal is discarded in favour of the dashboard —
 * including protocol-relative `//evil.com`, which `new URL(x, origin)` happily
 * resolves off-site.
 */
export function safeRedirect(raw: string | undefined, fallback = "/dashboard") {
  if (!raw) return fallback;
  if (!raw.startsWith("/") || raw.startsWith("//")) return fallback;

  const path = raw.startsWith(`${BASEPATH}/`)
    ? raw.slice(BASEPATH.length)
    : raw;
  if (!path.startsWith("/") || path.startsWith("//")) return fallback;
  // No scheme, no host, no backslash smuggling.
  if (/[\\:]/.test(path.split("?")[0])) return fallback;
  return path;
}
